// extracted by mini-css-extract-plugin
export var sbShowMain = "toc-module--sb-show-main--1b8c-";
export var toc = "toc-module--toc--2ycds";
export var list = "toc-module--list--39xtr";
export var title = "toc-module--title--2FPTk";